import Partner1 from './assets/partner-1.png';
import Partner2 from './assets/partner-2.png';
import Partner3 from './assets/partner-3.png';
import Partner4 from './assets/partner-4.png';
import Partner5 from './assets/partner-5.png';
import Partner6 from './assets/partner-6.png';
import Partner7 from './assets/partner-7.png';
import Partner8 from './assets/partner-8.png';
import Partner9 from './assets/partner-9.png';
import Partner10 from './assets/partner-10.png';
import Partner11 from './assets/partner-11.png';
import Partner12 from './assets/partner-12.png';
import Partner13 from './assets/partner-13.svg';
import Partner14 from './assets/partner-14.png';
import Partner15 from './assets/partner-15.png';
import Partner16 from './assets/partner-16.png';
import Partner17 from './assets/partner-17.png';
import Partner18 from './assets/partner-18.png';
import Partner19 from './assets/partner-19.png';

export const partnersList1 = [
  {
    img: Partner18,
    name: 'Stepn',
    width: 405,
    height: 121,
  },
  {
    img: Partner15,
    name: 'Aptos',
    width: 254,
    height: 63,
  },
  { img: Partner10, name: 'Google cloud', width: 330, height: 84, containerWidth: 350 },
  { img: Partner1, name: 'Plume', width: 280, height: 68, containerWidth: 350 },
  { img: Partner12, name: 'ICP', width: 285, height: 52, containerWidth: 350 },
  { img: Partner19, name: 'Mooar', width: 278, height: 98 },
  {
    img: Partner14,
    name: 'Amnis',
    width: 270,
    height: 76,
  },
  {
    img: Partner16,
    name: 'Movementum',
    width: 314,
    height: 66,
  },
  { img: Partner8, name: 'Fragmetric', width: 309, height: 73, containerWidth: 350 },
  { img: Partner17, name: 'Movebit', width: 254, height: 60 },
  { img: Partner9, name: 'Searchfi', width: 265, height: 120, containerWidth: 350 },
  { img: Partner5, name: 'MxN Commerce', width: 165, height: 150, containerWidth: 165 },
  { img: Partner2, name: 'MxN Technology', width: 283, height: 132, containerWidth: 350 },

  { img: Partner3, name: 'MCM', width: 209, height: 69, containerWidth: 350 },
  { img: Partner7, name: 'Polytrade', width: 350, height: 50, containerWidth: 350 },
  { img: Partner4, name: 'Pinewood capital', width: 267, height: 91, containerWidth: 350 },
  { img: Partner11, name: 'Xraders', width: 333, height: 121, containerWidth: 350 },
  { img: Partner13, name: 'Eclipse Labs', width: 364, height: 86, containerWidth: 350 },
];
